function c(e, o) {
  return `org:${e}:user:${o}:inbox`;
}
function r(e, o) {
  return `org:${e}:feedbackRequest:${o}`;
}
const s = 4002, t = 4003, n = /* @__PURE__ */ new Set([
  s,
  t
]);
function a(e) {
  return e !== void 0 && n.has(e);
}
function i(e) {
  return e === s ? "You were removed from this team, so this content is no longer available." : "Your access to this content was revoked.";
}
export {
  i as c,
  r as f,
  a as i,
  c as t
};
//# sourceMappingURL=collabCloseCodes-DGgEuAqm.js.map
